import { CSSObject } from "@emotion/react";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const getContainerPositionCss = (isSubNavMenu?: boolean): CSSObject => ({
  position: isSubNavMenu ? "initial" : "relative",

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    position: "inherit",
  },
});

export const absoluteContainerCss: CSSObject = {
  position: "absolute",
  zIndex: 13,

  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    top: "4rem",
    left: 0,
    right: 0,
  },
};

export const subNavMenuPositionCss = {
  [`@media (max-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    top: "0 !important",
  },
};
